import classnames from 'classnames';
import React from 'react';

type IProps = {
  type?: 1;
  label?: string;
  lock?: boolean;
};

export const Loading: React.FC<IProps> = ({ type, label, lock }) => {
  return (
    <>
      {lock ? (
        <div
          className={classnames('loading', {
            [`loading_type${type}`]: !!type,
          })}
        >
          <div className="loading__lock">
            <div className="loading__lock__icon">
              <span>...loading...</span>
            </div>
          </div>
          <h1 className="loading__title">{label}</h1>
        </div>
      ) : (
        <div
          className={classnames('loading', {
            [`loading_type${type}`]: !!type,
          })}
        >
          <div className="loading__standard">
            <span>...loading...</span>
          </div>
          <h1 className="loading__title">{label}</h1>
        </div>
      )}
    </>
  );
};
